// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html,
  body,
  #root {
  height: 100%;
  width: 100%;
}

  body {
  margin: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.tw .pointer-events-none {
  pointer-events: none;
}
.tw .visible {
  visibility: visible;
}
.tw .fixed {
  position: fixed;
}
.tw .absolute {
  position: absolute;
}
.tw .relative {
  position: relative;
}
.tw .sticky {
  position: sticky;
}
.tw .inset-0 {
  inset: 0px;
}
.tw .inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.tw .-left-2 {
  left: -0.5rem;
}
.tw .-right-2 {
  right: -0.5rem;
}
.tw .bottom-0 {
  bottom: 0px;
}
.tw .bottom-14 {
  bottom: 3.5rem;
}
.tw .left-0 {
  left: 0px;
}
.tw .left-3 {
  left: 0.75rem;
}
.tw .right-0 {
  right: 0px;
}
.tw .top-0 {
  top: 0px;
}
.tw .top-1\\/2 {
  top: 50%;
}
.tw .top-8 {
  top: 2rem;
}
.tw .z-10 {
  z-index: 10;
}
.tw .z-20 {
  z-index: 20;
}
.tw .z-30 {
  z-index: 30;
}
.tw .z-50 {
  z-index: 50;
}
.tw .z-\\[100\\] {
  z-index: 100;
}
.tw .z-\\[80\\] {
  z-index: 80;
}
.tw .col-auto {
  grid-column: auto;
}
.tw .mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.tw .my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.tw .my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.tw .mb-0 {
  margin-bottom: 0px;
}
.tw .mb-1 {
  margin-bottom: 0.25rem;
}
.tw .mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.tw .mb-2 {
  margin-bottom: 0.5rem;
}
.tw .mb-3 {
  margin-bottom: 0.75rem;
}
.tw .mb-4 {
  margin-bottom: 1rem;
}
.tw .mb-5 {
  margin-bottom: 1.25rem;
}
.tw .mb-6 {
  margin-bottom: 1.5rem;
}
.tw .mb-8 {
  margin-bottom: 2rem;
}
.tw .mb-\\[2px\\] {
  margin-bottom: 2px;
}
.tw .me-1 {
  margin-inline-end: 0.25rem;
}
.tw .me-2 {
  margin-inline-end: 0.5rem;
}
.tw .me-3 {
  margin-inline-end: 0.75rem;
}
.tw .ml-1 {
  margin-left: 0.25rem;
}
.tw .ms-2 {
  margin-inline-start: 0.5rem;
}
.tw .mt-0\\.5 {
  margin-top: 0.125rem;
}
.tw .mt-1 {
  margin-top: 0.25rem;
}
.tw .mt-1\\.5 {
  margin-top: 0.375rem;
}
.tw .mt-16 {
  margin-top: 4rem;
}
.tw .mt-2 {
  margin-top: 0.5rem;
}
.tw .mt-20 {
  margin-top: 5rem;
}
.tw .mt-3 {
  margin-top: 0.75rem;
}
.tw .mt-4 {
  margin-top: 1rem;
}
.tw .mt-5 {
  margin-top: 1.25rem;
}
.tw .mt-6 {
  margin-top: 1.5rem;
}
.tw .mt-\\[2px\\] {
  margin-top: 2px;
}
.tw .mt-auto {
  margin-top: auto;
}
.tw .line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tw .block {
  display: block;
}
.tw .inline {
  display: inline;
}
.tw .flex {
  display: flex;
}
.tw .inline-flex {
  display: inline-flex;
}
.tw .table {
  display: table;
}
.tw .grid {
  display: grid;
}
.tw .hidden {
  display: none;
}
.tw .h-1\\.5 {
  height: 0.375rem;
}
.tw .h-10 {
  height: 2.5rem;
}
.tw .h-11 {
  height: 2.75rem;
}
.tw .h-12 {
  height: 3rem;
}
.tw .h-14 {
  height: 3.5rem;
}
.tw .h-16 {
  height: 4rem;
}
.tw .h-2 {
  height: 0.5rem;
}
.tw .h-4 {
  height: 1rem;
}
.tw .h-9 {
  height: 2.25rem;
}
.tw .h-auto {
  height: auto;
}
.tw .h-full {
  height: 100%;
}
.tw .h-screen {
  height: 100vh;
}
.tw .max-h-\\[420px\\] {
  max-height: 420px;
}
.tw .max-h-\\[520px\\] {
  max-height: 520px;
}
.tw .max-h-\\[70vh\\] {
  max-height: 70vh;
}
.tw .min-h-0 {
  min-height: 0px;
}
.tw .min-h-\\[220px\\] {
  min-height: 220px;
}
.tw .min-h-\\[44px\\] {
  min-height: 44px;
}
.tw .min-h-screen {
  min-height: 100vh;
}
.tw .w-1 {
  width: 0.25rem;
}
.tw .w-10 {
  width: 2.5rem;
}
.tw .w-2 {
  width: 0.5rem;
}
.tw .w-20 {
  width: 5rem;
}
.tw .w-28 {
  width: 7rem;
}
.tw .w-4 {
  width: 1rem;
}
.tw .w-40 {
  width: 10rem;
}
.tw .w-44 {
  width: 11rem;
}
.tw .w-9 {
  width: 2.25rem;
}
.tw .w-\\[58\\%\\] {
  width: 58%;
}
.tw .w-\\[68\\%\\] {
  width: 68%;
}
.tw .w-fit {
  width: fit-content;
}
.tw .w-full {
  width: 100%;
}
.tw .min-w-0 {
  min-width: 0px;
}
.tw .min-w-\\[180px\\] {
  min-width: 180px;
}
.tw .min-w-\\[260px\\] {
  min-width: 260px;
}
.tw .min-w-\\[280px\\] {
  min-width: 280px;
}
.tw .min-w-full {
  min-width: 100%;
}
.tw .max-w-2xl {
  max-width: 42rem;
}
.tw .max-w-3xl {
  max-width: 48rem;
}
.tw .max-w-4xl {
  max-width: 56rem;
}
.tw .max-w-5xl {
  max-width: 64rem;
}
.tw .max-w-6xl {
  max-width: 72rem;
}
.tw .max-w-\\[1200px\\] {
  max-width: 1200px;
}
.tw .max-w-\\[1800px\\] {
  max-width: 1800px;
}
.tw .max-w-\\[360px\\] {
  max-width: 360px;
}
.tw .max-w-\\[42rem\\] {
  max-width: 42rem;
}
.tw .max-w-\\[920px\\] {
  max-width: 920px;
}
.tw .max-w-lg {
  max-width: 32rem;
}
.tw .max-w-md {
  max-width: 28rem;
}
.tw .max-w-sm {
  max-width: 24rem;
}
.tw .max-w-xl {
  max-width: 36rem;
}
.tw .flex-1 {
  flex: 1 1;
}
.tw .shrink-0 {
  flex-shrink: 0;
}
.tw .border-collapse {
  border-collapse: collapse;
}
.tw .-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw .rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw .scale-\\[1\\.02\\] {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw .transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.tw .animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.tw .animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.tw .animate-spin {
  animation: spin 1s linear infinite;
}
.tw .cursor-col-resize {
  cursor: col-resize;
}
.tw .cursor-pointer {
  cursor: pointer;
}
.tw .resize-none {
  resize: none;
}
.tw .resize-y {
  resize: vertical;
}
.tw .resize {
  resize: both;
}
.tw .list-disc {
  list-style-type: disc;
}
.tw .list-none {
  list-style-type: none;
}
.tw .grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.tw .grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.tw .grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.tw .flex-col {
  flex-direction: column;
}
.tw .flex-wrap {
  flex-wrap: wrap;
}
.tw .items-start {
  align-items: flex-start;
}
.tw .items-end {
  align-items: flex-end;
}
.tw .items-center {
  align-items: center;
}
.tw .justify-start {
  justify-content: flex-start;
}
.tw .justify-end {
  justify-content: flex-end;
}
.tw .justify-center {
  justify-content: center;
}
.tw .justify-between {
  justify-content: space-between;
}
.tw .gap-1 {
  gap: 0.25rem;
}
.tw .gap-2 {
  gap: 0.5rem;
}
.tw .gap-3 {
  gap: 0.75rem;
}
.tw .gap-4 {
  gap: 1rem;
}
.tw .gap-6 {
  gap: 1.5rem;
}
.tw :is(.space-y-1 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.tw :is(.space-y-1\\.5 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.tw :is(.space-y-2 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.tw :is(.space-y-3 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.tw :is(.space-y-4 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.tw :is(.space-y-6 > :not([hidden]) ~ :not([hidden])) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.tw .overflow-hidden {
  overflow: hidden;
}
.tw .overflow-x-auto {
  overflow-x: auto;
}
.tw .overflow-y-auto {
  overflow-y: auto;
}
.tw .truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tw .whitespace-pre-wrap {
  white-space: pre-wrap;
}
.tw .break-all {
  word-break: break-all;
}
.tw .rounded {
  border-radius: 0.25rem;
}
.tw .rounded-2xl {
  border-radius: 1rem;
}
.tw .rounded-3xl {
  border-radius: 1.5rem;
}
.tw .rounded-\\[18px\\] {
  border-radius: 18px;
}
.tw .rounded-\\[20px\\] {
  border-radius: 20px;
}
.tw .rounded-\\[28px\\] {
  border-radius: 28px;
}
.tw .rounded-full {
  border-radius: 9999px;
}
.tw .rounded-lg {
  border-radius: 0.5rem;
}
.tw .rounded-md {
  border-radius: 0.375rem;
}
.tw .rounded-xl {
  border-radius: 0.75rem;
}
.tw .rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.tw .rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
.tw .border {
  border-width: 1px;
}
.tw .border-0 {
  border-width: 0px;
}
.tw .border-4 {
  border-width: 4px;
}
.tw .border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.tw .border-b {
  border-bottom-width: 1px;
}
.tw .border-r {
  border-right-width: 1px;
}
.tw .border-t {
  border-top-width: 1px;
}
.tw .border-dashed {
  border-style: dashed;
}
.tw .border-none {
  border-style: none;
}
.tw .border-\\[\\#d9d9e3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 217 227 / var(--tw-border-opacity, 1));
}
.tw .border-\\[\\#e5e7eb\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.tw .border-\\[\\#ececf1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(236 236 241 / var(--tw-border-opacity, 1));
}
.tw .border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.tw .border-black\\/10 {
  border-color: rgb(0 0 0 / 0.1);
}
.tw .border-black\\/5 {
  border-color: rgb(0 0 0 / 0.05);
}
.tw .border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.tw .border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.tw .border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.tw .border-neutral-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity, 1));
}
.tw .border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.tw .border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.tw .border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.tw .border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.tw .border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.tw .border-slate-900 {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.tw .border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.tw .border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.tw .border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.tw .border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.tw .border-zinc-200 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.tw .border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.tw .border-t-neutral-900 {
  --tw-border-opacity: 1;
  border-top-color: rgb(23 23 23 / var(--tw-border-opacity, 1));
}
.tw .bg-\\[\\#111\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 17 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#202123\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(32 33 35 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#6e6e80\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(110 110 128 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#b8b8c7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(184 184 199 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#ececf1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 241 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#f3f4f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#f7f7f8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 248 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[\\#fafafa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.tw .bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.tw .bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.tw .bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.tw .bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.tw .bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.tw .bg-black\\/\\[0\\.02\\] {
  background-color: rgb(0 0 0 / 0.02);
}
.tw .bg-black\\/\\[0\\.04\\] {
  background-color: rgb(0 0 0 / 0.04);
}
.tw .bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.tw .bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.tw .bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.tw .bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.tw .bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.tw .bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.tw .bg-neutral-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}
.tw .bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.tw .bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.tw .bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.tw .bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.tw .bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.tw .bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.tw .bg-slate-900\\/45 {
  background-color: rgb(15 23 42 / 0.45);
}
.tw .bg-slate-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.tw .bg-transparent {
  background-color: transparent;
}
.tw .bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.tw .bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.tw .bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.tw .bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.tw .bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.tw .bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.tw .bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.tw .bg-zinc-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.tw .bg-\\[radial-gradient\\(circle_at_20\\%_20\\%\\2c rgba\\(45\\2c 212\\2c 191\\2c 0\\.28\\)\\2c transparent_42\\%\\)\\2c radial-gradient\\(circle_at_78\\%_30\\%\\2c rgba\\(14\\2c 165\\2c 233\\2c 0\\.22\\)\\2c transparent_40\\%\\)\\] {
  background-image: radial-gradient(circle at 20% 20%,rgba(45,212,191,0.28),transparent 42%),radial-gradient(circle at 78% 30%,rgba(14,165,233,0.22),transparent 40%);
}
.tw .bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.tw .bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.tw .from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.tw .from-red-50 {
  --tw-gradient-from: #fef2f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.tw .from-slate-900 {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.tw .from-slate-950\\/90 {
  --tw-gradient-from: rgb(2 6 23 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(2 6 23 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.tw .via-slate-800 {
  --tw-gradient-to: rgb(30 41 59 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e293b var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.tw .via-slate-900\\/75 {
  --tw-gradient-to: rgb(15 23 42 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(15 23 42 / 0.75) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.tw .to-rose-50 {
  --tw-gradient-to: #fff1f2 var(--tw-gradient-to-position);
}
.tw .to-slate-700 {
  --tw-gradient-to: #334155 var(--tw-gradient-to-position);
}
.tw .to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.tw .to-teal-900\\/70 {
  --tw-gradient-to: rgb(19 78 74 / 0.7) var(--tw-gradient-to-position);
}
.tw .bg-cover {
  background-size: cover;
}
.tw .bg-center {
  background-position: center;
}
.tw .object-cover {
  object-fit: cover;
}
.tw .p-0 {
  padding: 0px;
}
.tw .p-1 {
  padding: 0.25rem;
}
.tw .p-1\\.5 {
  padding: 0.375rem;
}
.tw .p-10 {
  padding: 2.5rem;
}
.tw .p-2 {
  padding: 0.5rem;
}
.tw .p-3 {
  padding: 0.75rem;
}
.tw .p-4 {
  padding: 1rem;
}
.tw .p-5 {
  padding: 1.25rem;
}
.tw .p-6 {
  padding: 1.5rem;
}
.tw .p-8 {
  padding: 2rem;
}
.tw .px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.tw .px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.tw .px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.tw .px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw .px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.tw .px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw .px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw .px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw .px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw .py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.tw .py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.tw .py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.tw .py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw .py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.tw .py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw .py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.tw .py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.tw .py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.tw .py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.tw .pb-2 {
  padding-bottom: 0.5rem;
}
.tw .pb-20 {
  padding-bottom: 5rem;
}
.tw .pb-24 {
  padding-bottom: 6rem;
}
.tw .pb-28 {
  padding-bottom: 7rem;
}
.tw .pb-3 {
  padding-bottom: 0.75rem;
}
.tw .pb-4 {
  padding-bottom: 1rem;
}
.tw .pl-10 {
  padding-left: 2.5rem;
}
.tw .pl-5 {
  padding-left: 1.25rem;
}
.tw .pr-1 {
  padding-right: 0.25rem;
}
.tw .pr-3 {
  padding-right: 0.75rem;
}
.tw .pt-1\\.5 {
  padding-top: 0.375rem;
}
.tw .pt-12 {
  padding-top: 3rem;
}
.tw .pt-2 {
  padding-top: 0.5rem;
}
.tw .pt-3 {
  padding-top: 0.75rem;
}
.tw .pt-5 {
  padding-top: 1.25rem;
}
.tw .text-left {
  text-align: left;
}
.tw .text-center {
  text-align: center;
}
.tw .text-start {
  text-align: start;
}
.tw .text-end {
  text-align: end;
}
.tw .align-top {
  vertical-align: top;
}
.tw .align-middle {
  vertical-align: middle;
}
.tw .text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.tw .text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.tw .text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.tw .text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.tw .text-\\[10px\\] {
  font-size: 10px;
}
.tw .text-\\[11px\\] {
  font-size: 11px;
}
.tw .text-\\[12px\\] {
  font-size: 12px;
}
.tw .text-\\[15px\\] {
  font-size: 15px;
}
.tw .text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.tw .text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw .text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw .text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw .text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.tw .font-bold {
  font-weight: 700;
}
.tw .font-medium {
  font-weight: 500;
}
.tw .font-semibold {
  font-weight: 600;
}
.tw .uppercase {
  text-transform: uppercase;
}
.tw .italic {
  font-style: italic;
}
.tw .leading-5 {
  line-height: 1.25rem;
}
.tw .leading-6 {
  line-height: 1.5rem;
}
.tw .leading-7 {
  line-height: 1.75rem;
}
.tw .leading-relaxed {
  line-height: 1.625;
}
.tw .leading-tight {
  line-height: 1.25;
}
.tw .tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tw .tracking-\\[0\\.16em\\] {
  letter-spacing: 0.16em;
}
.tw .tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tw .tracking-\\[0\\.22em\\] {
  letter-spacing: 0.22em;
}
.tw .tracking-tight {
  letter-spacing: -0.025em;
}
.tw .tracking-wide {
  letter-spacing: 0.025em;
}
.tw .tracking-widest {
  letter-spacing: 0.1em;
}
.tw .text-\\[\\#111827\\] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.tw .text-\\[\\#202123\\] {
  --tw-text-opacity: 1;
  color: rgb(32 33 35 / var(--tw-text-opacity, 1));
}
.tw .text-\\[\\#6e6e80\\] {
  --tw-text-opacity: 1;
  color: rgb(110 110 128 / var(--tw-text-opacity, 1));
}
.tw .text-\\[\\#8e8ea0\\] {
  --tw-text-opacity: 1;
  color: rgb(142 142 160 / var(--tw-text-opacity, 1));
}
.tw .text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.tw .text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.tw .text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.tw .text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.tw .text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.tw .text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity, 1));
}
.tw .text-neutral-700 {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity, 1));
}
.tw .text-neutral-800 {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.tw .text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity, 1));
}
.tw .text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.tw .text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.tw .text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.tw .text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.tw .text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.tw .text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.tw .text-slate-100 {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.tw .text-slate-200\\/90 {
  color: rgb(226 232 240 / 0.9);
}
.tw .text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.tw .text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.tw .text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.tw .text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.tw .text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.tw .text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.tw .text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.tw .text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.tw .text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.tw .text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.tw .text-zinc-900 {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.tw .opacity-0 {
  opacity: 0;
}
.tw .opacity-100 {
  opacity: 1;
}
.tw .opacity-70 {
  opacity: 0.7;
}
.tw .shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-\\[0_-1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.02\\)\\] {
  --tw-shadow: 0 -1px 2px rgba(0,0,0,0.02);
  --tw-shadow-colored: 0 -1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-\\[0_4px_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 4px 20px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-\\[0_4px_20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 4px 20px rgba(0,0,0,0.06);
  --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw .shadow-slate-300\\/50 {
  --tw-shadow-color: rgb(203 213 225 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.tw .outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tw .outline {
  outline-style: solid;
}
.tw .filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.tw .backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.tw .transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw .transition-\\[left\\] {
  transition-property: left;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw .transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw .transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw .transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw .duration-150 {
  transition-duration: 150ms;
}
.tw .duration-700 {
  transition-duration: 700ms;
}
.tw  .container-fluid {
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw  .row {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  display: flex;
  flex-wrap: wrap;
}
.tw  :is(.row > *) {
  width: 100%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw  .col,:is(
  .tw .col-12),:is(
  .tw .col-auto),:is(
  .tw .col-3),:is(
  .tw .col-6),:is(
  .tw .col-9),:is(
  .tw .col-md-4),:is(
  .tw .col-md-6),:is(
  .tw .col-md-8),:is(
  .tw .col-md-10),:is(
  .tw .col-md-12),:is(
  .tw .col-lg-8) {
  width: 100%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
@media (min-width: 768px) {
    .tw .col-md-4 {
      width: 33.333333%;
    }

    .tw .col-md-6 {
      width: 50%;
    }

    .tw .col-md-8 {
      width: 66.666667%;
    }

    .tw .col-md-10 {
      width: 83.333333%;
    }

    .tw .col-md-12 {
      width: 100%;
    }
    .tw .col-md-4 {
      width: 33.333333%;
    }

    .tw .col-md-6 {
      width: 50%;
    }

    .tw .col-md-8 {
      width: 66.666667%;
    }

    .tw .col-md-10 {
      width: 83.333333%;
    }

    .tw .col-md-12 {
      width: 100%;
    }
    .tw .col-md-4 {
      width: 33.333333%;
    }

    .tw .col-md-6 {
      width: 50%;
    }

    .tw .col-md-8 {
      width: 66.666667%;
    }

    .tw .col-md-10 {
      width: 83.333333%;
    }

    .tw .col-md-12 {
      width: 100%;
    }
    .tw .col-md-4 {
      width: 33.333333%;
    }

    .tw .col-md-6 {
      width: 50%;
    }

    .tw .col-md-8 {
      width: 66.666667%;
    }

    .tw .col-md-10 {
      width: 83.333333%;
    }

    .tw .col-md-12 {
      width: 100%;
    }
    .tw .col-md-4 {
      width: 33.333333%;
    }

    .tw .col-md-6 {
      width: 50%;
    }

    .tw .col-md-8 {
      width: 66.666667%;
    }

    .tw .col-md-10 {
      width: 83.333333%;
    }

    .tw .col-md-12 {
      width: 100%;
    }
  }
@media (min-width: 1024px) {
    .tw .col-lg-8 {
      width: 66.666667%;
    }
  }
.tw  .d-flex {
  display: flex;
}
.tw .d-block {
    display: block;
  }
.tw .d-inline-block {
    display: inline-block;
  }
.tw  .justify-content-center {
  justify-content: center;
}
.tw  .justify-content-between {
  justify-content: space-between;
}
.tw  .justify-content-start {
  justify-content: flex-start;
}
.tw  .justify-content-end {
  justify-content: flex-end;
}
.tw  .align-items-center {
  align-items: center;
}
.tw  .align-items-start {
  align-items: flex-start;
}
.tw  .align-items-end {
  align-items: flex-end;
}
.tw .w-100 {
    width: 100%;
  }
.tw .h-100 {
    height: 100%;
  }
.tw  .rounded-circle {
  border-radius: 9999px;
}
.tw  .form-control,:is(
  .tw .form-select) {
  width: 100%;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tw  .form-control:focus,:is(
  .tw .form-select:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.tw  .form-control,:is(
  .tw .form-select) {
  width: 100%;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tw  .form-control:focus,:is(
  .tw .form-select:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.tw  .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: transparent;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tw  .btn-sm {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
}
.tw  .btn-dark {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.tw  .btn-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.tw  .btn-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.tw  .btn-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.tw  .btn-outline-dark {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.tw  .btn-outline-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.tw  .btn-outline-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.tw  .btn-outline-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.tw  .btn-outline-danger {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.tw  .btn-outline-danger:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.tw  .btn-close {
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.tw  .alert {
  border-radius: 0.5rem;
  border-width: 1px;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw  .alert-danger {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.tw  .card {
  border-radius: 0.75rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.tw  .card-body {
  padding: 1rem;
}
.tw  .table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw  :is(.table th),:is(
  .tw :is(.table td)) {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw  :is(.table-striped tbody tr:nth-child(even)) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.tw  :is(.table-hover tbody tr:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.tw  .table-responsive {
  width: 100%;
  overflow-x: auto;
}
.tw  .modal {
  position: fixed;
  inset: 0px;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 0.4);
}
.tw  .modal-dialog {
  width: 100%;
  max-width: 42rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw  .modal-lg {
  max-width: 56rem;
}
.tw  .modal-content {
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw  .modal-header,:is(
  .tw .modal-footer) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw  .modal-header {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.tw  .modal-footer {
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.tw  .modal-body {
  padding: 1rem;
}
.tw  .nav {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
}
.tw  .spinner-border {
  display: inline-block;
  height: 2rem;
  width: 2rem;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.tw  .spinner-border {
  animation: spin 1s linear infinite;
  border-radius: 9999px;
  border-width: 4px;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
  --tw-border-opacity: 1;
  border-top-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.tw  .spinner-border-sm {
  height: 1rem;
  width: 1rem;
  border-width: 2px;
}
.tw  .visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.tw .\\[animation-delay\\:-0\\.15s\\] {
  animation-delay: -0.15s;
}
.tw .\\[animation-delay\\:-0\\.3s\\] {
  animation-delay: -0.3s;
}

/* Custom Scrollbar for Sidebar */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #c1c1c1; 
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8; 
}

/* For Firefox */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
.tw .placeholder\\:text-\\[\\#8e8ea0\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(142 142 160 / var(--tw-text-opacity, 1));
}
.tw .placeholder\\:text-neutral-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}
.tw .last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.tw .last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.tw .odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.tw .even\\:bg-slate-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.tw .focus-within\\:border-blue-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.tw .focus-within\\:border-cyan-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.tw .focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.tw .focus-within\\:ring-blue-500\\/20:focus-within {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.tw .focus-within\\:ring-cyan-500\\/20:focus-within {
  --tw-ring-color: rgb(6 182 212 / 0.2);
}
.tw .hover\\:border-\\[\\#d9d9e3\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 217 227 / var(--tw-border-opacity, 1));
}
.tw .hover\\:bg-\\[\\#d9d9e3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 227 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-\\[\\#ececf1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 241 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-\\[\\#f7f7f8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 248 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-\\[\\#f8f9fa\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-black\\/5:hover {
  background-color: rgb(0 0 0 / 0.05);
}
.tw .hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-slate-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:bg-zinc-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.tw .hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.tw .hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.tw .hover\\:text-slate-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.tw .focus\\:border-\\[\\#202123\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(32 33 35 / var(--tw-border-opacity, 1));
}
.tw .focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.tw .focus\\:border-slate-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.tw .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.tw .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.tw .focus\\:ring-black:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.tw .focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.tw .focus\\:ring-slate-900:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity, 1));
}
.tw .focus\\:ring-slate-900\\/10:focus {
  --tw-ring-color: rgb(15 23 42 / 0.1);
}
.tw .disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.tw .disabled\\:bg-zinc-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.tw .disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.tw .disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.tw .disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
@media (min-width: 640px) {

  .tw .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .tw .sm\\:p-8 {
    padding: 2rem;
  }
}
@media (min-width: 768px) {

  .tw .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .tw .md\\:flex-row {
    flex-direction: row;
  }

  .tw .md\\:items-start {
    align-items: flex-start;
  }

  .tw .md\\:items-center {
    align-items: center;
  }

  .tw .md\\:justify-end {
    justify-content: flex-end;
  }

  .tw .md\\:justify-between {
    justify-content: space-between;
  }
}
@media (min-width: 1024px) {

  .tw .lg\\:block {
    display: block;
  }

  .tw .lg\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .tw .lg\\:w-\\[42\\%\\] {
    width: 42%;
  }

  .tw .lg\\:min-w-\\[320px\\] {
    min-width: 320px;
  }

  .tw .lg\\:flex-row {
    flex-direction: row;
  }

  .tw .lg\\:items-end {
    align-items: flex-end;
  }

  .tw .lg\\:justify-between {
    justify-content: space-between;
  }

  .tw .lg\\:p-6 {
    padding: 1.5rem;
  }

  .tw .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .tw .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}
@media (min-width: 1280px) {

  .tw .xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .tw .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .tw .xl\\:grid-cols-\\[1\\.1fr_0\\.9fr\\] {
    grid-template-columns: 1.1fr 0.9fr;
  }
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;;;EAAA,YAAc;EAAd;AAAc;;EAAd;EAAA,WAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,+HAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,gDAAc;EAAd,mCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAgBf;EAAA,WAAkB;EAAlB,kBAAkB;EAAlB;AAAkB;AAIlB;EAAA,oBAA2B;EAA3B,qBAA2B;EAA3B,aAA2B;EAA3B;AAA2B;AAI3B;EAAA,WAAkB;EAAlB,oBAAkB;EAAlB;AAAkB;AAelB;;;;;;;;;;;;EAAA,WAAkB;EAAlB,oBAAkB;EAAlB;AAAkB;AAGpB;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;IAlBA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;IAlBA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;IAlBA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;IAlBA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;EACF;AAEA;IACE;MACE,iBAAiB;IACnB;EACF;AAGE;EAAA;AAAW;AAGb;IACE,cAAc;EAChB;AAEA;IACE,qBAAqB;EACvB;AAGE;EAAA;AAAqB;AAIrB;EAAA;AAAsB;AAItB;EAAA;AAAoB;AAIpB;EAAA;AAAkB;AAIlB;EAAA;AAAmB;AAInB;EAAA;AAAkB;AAIlB;EAAA;AAAgB;AAGlB;IACE,WAAW;EACb;AAEA;IACE,YAAY;EACd;AAOE;EAAA;AAAmB;AAKnB;;EAAA,WAAkJ;EAAlJ,qBAAkJ;EAAlJ,iBAAkJ;EAAlJ,sBAAkJ;EAAlJ,4DAAkJ;EAAlJ,kBAAkJ;EAAlJ,4DAAkJ;EAAlJ,qBAAkJ;EAAlJ,sBAAkJ;EAAlJ,mBAAkJ;EAAlJ,sBAAkJ;EAAlJ,mBAAkJ;EAAlJ,oBAAkJ;EAAlJ,8BAAkJ;EAAlJ;AAAkJ;AAAlJ;;EAAA,sBAAkJ;EAAlJ,2DAAkJ;EAAlJ,2GAAkJ;EAAlJ,yGAAkJ;EAAlJ,4FAAkJ;EAAlJ;AAAkJ;AAAlJ;;EAAA,WAAkJ;EAAlJ,qBAAkJ;EAAlJ,iBAAkJ;EAAlJ,sBAAkJ;EAAlJ,4DAAkJ;EAAlJ,kBAAkJ;EAAlJ,4DAAkJ;EAAlJ,qBAAkJ;EAAlJ,sBAAkJ;EAAlJ,mBAAkJ;EAAlJ,sBAAkJ;EAAlJ,mBAAkJ;EAAlJ,oBAAkJ;EAAlJ,8BAAkJ;EAAlJ;AAAkJ;AAAlJ;;EAAA,sBAAkJ;EAAlJ,2DAAkJ;EAAlJ,2GAAkJ;EAAlJ,yGAAkJ;EAAlJ,4FAAkJ;EAAlJ;AAAkJ;AAIlJ;EAAA,oBAA4H;EAA5H,mBAA4H;EAA5H,uBAA4H;EAA5H,qBAA4H;EAA5H,iBAA4H;EAA5H,yBAA4H;EAA5H,qBAA4H;EAA5H,sBAA4H;EAA5H,mBAA4H;EAA5H,sBAA4H;EAA5H,mBAA4H;EAA5H,oBAA4H;EAA5H,gBAA4H;EAA5H,wJAA4H;EAA5H,wDAA4H;EAA5H;AAA4H;AAI5H;EAAA,oBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,uBAAwB;EAAxB,kBAAwB;EAAxB;AAAwB;AAQxB;EAAA,sBAAkE;EAAlE,yDAAkE;EAAlE,kBAAkE;EAAlE,yDAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;AAAlE;EAAA,kBAAkE;EAAlE;AAAkE;AAIlE;EAAA,sBAAkE;EAAlE,4DAAkE;EAAlE,kBAAkE;EAAlE,4DAAkE;EAAlE,oBAAkE;EAAlE;AAAkE;AAAlE;EAAA,kBAAkE;EAAlE;AAAkE;AAIlE;EAAA,sBAAiE;EAAjE,4DAAiE;EAAjE,kBAAiE;EAAjE,4DAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;AAAjE;EAAA,kBAAiE;EAAjE;AAAiE;AAIjE;EAAA,sBAAiE;EAAjE,4DAAiE;EAAjE,kBAAiE;EAAjE,4DAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;AAAjE;EAAA,kBAAiE;EAAjE;AAAiE;AAIjE;EAAA,sBAA2D;EAA3D,4DAA2D;EAA3D,kBAA2D;EAA3D,4DAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;AAA3D;EAAA,kBAA2D;EAA3D;AAA2D;AAI3D;EAAA,cAA0D;EAA1D,aAA0D;EAA1D,uBAA0D;EAA1D,iBAA0D;EAA1D,sBAA0D;EAA1D,4DAA0D;EAA1D,kBAA0D;EAA1D;AAA0D;AAI1D;EAAA,qBAA0C;EAA1C,iBAA0C;EAA1C,qBAA0C;EAA1C,sBAA0C;EAA1C,mBAA0C;EAA1C,sBAA0C;EAA1C,mBAA0C;EAA1C;AAA0C;AAI1C;EAAA,sBAA4C;EAA5C,4DAA4C;EAA5C,kBAA4C;EAA5C,4DAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;AAI5C;EAAA,sBAAkD;EAAlD,iBAAkD;EAAlD,sBAAkD;EAAlD,4DAAkD;EAAlD,kBAAkD;EAAlD;AAAkD;AAIlD;EAAA;AAAU;AAIV;EAAA,WAA+C;EAA/C,yBAA+C;EAA/C,gBAA+C;EAA/C,mBAA+C;EAA/C;AAA+C;AAK/C;;EAAA,iBAAwC;EAAxC,sBAAwC;EAAxC,4DAAwC;EAAxC,qBAAwC;EAAxC,sBAAwC;EAAxC,mBAAwC;EAAxC;AAAwC;AAIxC;EAAA,kBAAkB;EAAlB;AAAkB;AAIlB;EAAA,kBAAmB;EAAnB;AAAmB;AAInB;EAAA,WAA6B;EAA7B;AAA6B;AAI7B;EAAA,eAAsE;EAAtE,UAAsE;EAAtE,WAAsE;EAAtE,aAAsE;EAAtE,mBAAsE;EAAtE,uBAAsE;EAAtE;AAAsE;AAItE;EAAA,WAA4B;EAA5B,gBAA4B;EAA5B,kBAA4B;EAA5B;AAA4B;AAI5B;EAAA;AAAgB;AAIhB;EAAA,sBAAoC;EAApC,kBAAoC;EAApC,4DAAoC;EAApC,gFAAoC;EAApC,oGAAoC;EAApC;AAAoC;AAKpC;;EAAA,aAAkD;EAAlD,mBAAkD;EAAlD,8BAAkD;EAAlD,kBAAkD;EAAlD,mBAAkD;EAAlD,oBAAkD;EAAlD;AAAkD;AAIlD;EAAA,wBAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAIhC;EAAA,qBAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;AAIhC;EAAA;AAAU;AAIV;EAAA,WAAwB;EAAxB,qBAAwB;EAAxB;AAAwB;AAQxB;EAAA,qBAAkG;EAAlG,YAAkG;EAAlG;AAAkG;AAAlG;;EAAA;IAAA;EAAkG;AAAA;AAAlG;EAAA,kCAAkG;EAAlG,qBAAkG;EAAlG,iBAAkG;EAAlG,4DAAkG;EAAlG,sBAAkG;EAAlG;AAAkG;AAIlG;EAAA,YAAuB;EAAvB,WAAuB;EAAvB;AAAuB;AAIvB;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd,UAAc;EAAd,YAAc;EAAd,gBAAc;EAAd,sBAAc;EAAd,mBAAc;EAAd;AAAc;AA9PlB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAkQnB,iCAAiC;AACjC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,gCAAgC;AAClC;AA5RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,sBA+RA;EA/RA;AA+RA;AA/RA;EAAA,sBA+RA;EA/RA;AA+RA;AA/RA;EAAA,2GA+RA;EA/RA,yGA+RA;EA/RA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA,sBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA,sBA+RA;EA/RA;AA+RA;AA/RA;EAAA,sBA+RA;EA/RA;AA+RA;AA/RA;EAAA,sBA+RA;EA/RA;AA+RA;AA/RA;EAAA,8BA+RA;EA/RA;AA+RA;AA/RA;EAAA,2GA+RA;EA/RA,yGA+RA;EA/RA;AA+RA;AA/RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA,oBA+RA;EA/RA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA,kBA+RA;EA/RA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;EAAA;AA+RA;AA/RA;;EAAA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;AAAA;AA/RA;;EAAA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;AAAA;AA/RA;;EAAA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA,iBA+RA;IA/RA;EA+RA;;EA/RA;IAAA,mBA+RA;IA/RA;EA+RA;AAAA;AA/RA;;EAAA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;;EA/RA;IAAA;EA+RA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  html,\n  body,\n  #root {\n    @apply h-full w-full;\n  }\n\n  body {\n    @apply m-0 bg-slate-100 font-sans text-[13px] text-slate-800 antialiased;\n  }\n}\n\n@layer utilities {\n  .container-fluid {\n    @apply w-full px-4;\n  }\n\n  .row {\n    @apply -mx-2 flex flex-wrap;\n  }\n\n  .row > * {\n    @apply w-full px-2;\n  }\n\n  .col,\n  .col-12,\n  .col-auto,\n  .col-3,\n  .col-6,\n  .col-9,\n  .col-md-4,\n  .col-md-6,\n  .col-md-8,\n  .col-md-10,\n  .col-md-12,\n  .col-lg-8 {\n    @apply w-full px-2;\n  }\n\n  @media (min-width: 768px) {\n    .col-md-4 {\n      width: 33.333333%;\n    }\n\n    .col-md-6 {\n      width: 50%;\n    }\n\n    .col-md-8 {\n      width: 66.666667%;\n    }\n\n    .col-md-10 {\n      width: 83.333333%;\n    }\n\n    .col-md-12 {\n      width: 100%;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .col-lg-8 {\n      width: 66.666667%;\n    }\n  }\n\n  .d-flex {\n    @apply flex;\n  }\n\n  .d-block {\n    display: block;\n  }\n\n  .d-inline-block {\n    display: inline-block;\n  }\n\n  .justify-content-center {\n    @apply justify-center;\n  }\n\n  .justify-content-between {\n    @apply justify-between;\n  }\n\n  .justify-content-start {\n    @apply justify-start;\n  }\n\n  .justify-content-end {\n    @apply justify-end;\n  }\n\n  .align-items-center {\n    @apply items-center;\n  }\n\n  .align-items-start {\n    @apply items-start;\n  }\n\n  .align-items-end {\n    @apply items-end;\n  }\n\n  .w-100 {\n    width: 100%;\n  }\n\n  .h-100 {\n    height: 100%;\n  }\n\n  .img-fluid {\n    @apply h-auto max-w-full;\n  }\n\n  .rounded-circle {\n    @apply rounded-full;\n  }\n\n  .form-control,\n  .form-select {\n    @apply w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20;\n  }\n\n  .btn {\n    @apply inline-flex items-center justify-center rounded-lg border border-transparent px-3 py-2 text-sm font-medium transition;\n  }\n\n  .btn-sm {\n    @apply px-2 py-1 text-xs;\n  }\n\n  .btn-lg {\n    @apply px-4 py-2.5 text-base;\n  }\n\n  .btn-dark {\n    @apply border-slate-900 bg-slate-900 text-white hover:bg-slate-800;\n  }\n\n  .btn-secondary {\n    @apply border-slate-300 bg-slate-500 text-white hover:bg-slate-600;\n  }\n\n  .btn-outline-dark {\n    @apply border-slate-400 bg-white text-slate-700 hover:bg-slate-50;\n  }\n\n  .btn-outline-secondary {\n    @apply border-slate-300 bg-white text-slate-700 hover:bg-slate-50;\n  }\n\n  .btn-outline-danger {\n    @apply border-red-300 bg-white text-red-600 hover:bg-red-50;\n  }\n\n  .btn-close {\n    @apply h-6 w-6 rounded-md border border-slate-300 bg-white;\n  }\n\n  .alert {\n    @apply rounded-lg border px-3 py-2 text-sm;\n  }\n\n  .alert-danger {\n    @apply border-red-200 bg-red-50 text-red-700;\n  }\n\n  .card {\n    @apply rounded-xl border border-slate-200 bg-white;\n  }\n\n  .card-body {\n    @apply p-4;\n  }\n\n  .table {\n    @apply w-full border-collapse text-left text-sm;\n  }\n\n  .table th,\n  .table td {\n    @apply border border-slate-200 px-3 py-2;\n  }\n\n  .table-striped tbody tr:nth-child(even) {\n    @apply bg-slate-50;\n  }\n\n  .table-hover tbody tr:hover {\n    @apply bg-slate-100;\n  }\n\n  .table-responsive {\n    @apply w-full overflow-x-auto;\n  }\n\n  .modal {\n    @apply fixed inset-0 z-50 flex items-center justify-center bg-black/40;\n  }\n\n  .modal-dialog {\n    @apply w-full max-w-2xl px-4;\n  }\n\n  .modal-lg {\n    @apply max-w-4xl;\n  }\n\n  .modal-content {\n    @apply rounded-xl bg-white shadow-xl;\n  }\n\n  .modal-header,\n  .modal-footer {\n    @apply flex items-center justify-between px-4 py-3;\n  }\n\n  .modal-header {\n    @apply border-b border-slate-200;\n  }\n\n  .modal-footer {\n    @apply border-t border-slate-200;\n  }\n\n  .modal-body {\n    @apply p-4;\n  }\n\n  .nav {\n    @apply m-0 list-none p-0;\n  }\n\n  .nav-link {\n    @apply block rounded-lg px-3 py-2 text-sm;\n  }\n\n  .spinner-border {\n    @apply inline-block h-8 w-8 animate-spin rounded-full border-4 border-slate-300 border-t-slate-700;\n  }\n\n  .spinner-border-sm {\n    @apply h-4 w-4 border-2;\n  }\n\n  .visually-hidden {\n    @apply sr-only;\n  }\n}\n\n/* Custom Scrollbar for Sidebar */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #c1c1c1; \n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8; \n}\n\n/* For Firefox */\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f1f1f1;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
